import { ListViewModel, ListViewModelImpl } from '../horizontallist/listviewmodel';

export interface DropDownListViewModel<T> extends ListViewModel<T>
{
   
}

export class DropDownListViewModelImpl<T> extends ListViewModelImpl<T> implements DropDownListViewModel<T>
{
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistviewmodel.ts